import { _, mui, React, ts } from '_core';

type RiskModelStyleProps = {
  id: string;
  value: string[];
  setValue: (_value: ts.types.widgets.common.RiskFactorsType[]) => void;
  options: string[];
};

const RiskModelStyle = ({ value, setValue, id, options }: RiskModelStyleProps) => {
  const handleChange = (e: React.ChangeEvent<any>, changedValue: string[]) => {
    setValue(
      changedValue.map((val) => ({
        type: ts.types.widgets.common.FACTOR_TYPE_ENUM.RISK_MODEL_STYLE,
        value: val,
        id,
      }))
    );
  };

  return (
    <mui.core.Grid container spacing={4} alignItems="center">
      <mui.core.Grid item xs={12} sm={4}>
        <mui.core.Typography variant="h6">Style Factors</mui.core.Typography>
      </mui.core.Grid>

      <mui.core.Grid item xs={12} sm={8}>
        <mui.core.Box>
          <mui.core.Autocomplete
            options={options}
            disableClearable
            multiple
            size="small"
            onChange={handleChange}
            getOptionLabel={(option) => _.startCase(option)}
            value={value}
            renderInput={(params) => <mui.core.TextField variant="outlined" {...params} fullWidth label="Category" />}
          />
        </mui.core.Box>
      </mui.core.Grid>
    </mui.core.Grid>
  );
};

export default RiskModelStyle;
